// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Tooltip-top___577a98bc3954c89f968,.Tooltip-top-start___ba4f7262b933d0b160c,.Tooltip-top-end___7c3fdf8921357db9fa3{flex-direction:column}.Tooltip-left__b06cc1a117b2b79ec1d2,.Tooltip-left-start__d72d853243e462135764,.Tooltip-left-end__e9f327bb9955918a27b3{flex-direction:row}.Tooltip-right___fa27f1df8119c652410,.Tooltip-right-start___675a6d2677daa22a930,.Tooltip-right-end___9a2bd05d666696f8886{flex-direction:row-reverse}.Tooltip-bottom___3ffa5eb2bad710738bd,.Tooltip-bottom-start___90ddaad10465d2be153,.Tooltip-bottom-end___63e99809c0620bc3a8f{flex-direction:column-reverse}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"top": "Tooltip-top___577a98bc3954c89f968",
	"top-start": "Tooltip-top-start___ba4f7262b933d0b160c",
	"top-end": "Tooltip-top-end___7c3fdf8921357db9fa3",
	"left": "Tooltip-left__b06cc1a117b2b79ec1d2",
	"left-start": "Tooltip-left-start__d72d853243e462135764",
	"left-end": "Tooltip-left-end__e9f327bb9955918a27b3",
	"right": "Tooltip-right___fa27f1df8119c652410",
	"right-start": "Tooltip-right-start___675a6d2677daa22a930",
	"right-end": "Tooltip-right-end___9a2bd05d666696f8886",
	"bottom": "Tooltip-bottom___3ffa5eb2bad710738bd",
	"bottom-start": "Tooltip-bottom-start___90ddaad10465d2be153",
	"bottom-end": "Tooltip-bottom-end___63e99809c0620bc3a8f"
};
export default ___CSS_LOADER_EXPORT___;
